import { useState } from 'react';
import styles from './VendorDetails.module.scss';
import useCalculateIntervalDate from '../../utils/hooks/useCalculateIntervalDate';
import useConvertDate from '../../utils/hooks/useConvertDate';

export default function VendorDetails(props) {
  const lastActivity = useConvertDate({date:props.user.last_sale_date,withHour:false});

  const [intervalDate] = useCalculateIntervalDate(false, props.user.created_at);
  // const lastActivity = (props.user.last_sale_date)?.slice(0,10);

  return (
    <>
        {
          props.user.last_sale_date &&
            <div className={`${styles.sellerInfoDetail} mb-1`}>
              <i className='bi bi-clock me-2 big'></i>
              <span className='me-2 d-lg-none d-xl-block'>Last Activity:</span>
              <span className={`${styles.detailValue}`}>
                {lastActivity}
              </span>
          </div>
        }
        <div className={`${styles.sellerInfoDetail} mb-1`}>
            <i className='bi bi-person-badge me-2 big'></i>
            <span className='me-2 d-lg-none d-xl-block'>Membership:</span>
            <span className={`${styles.detailValue}`}>
              {intervalDate && intervalDate}
            </span>
        </div>
        <div className={`${styles.sellerInfoDetail} mb-1`}>
            <i className='bi bi-box-seam me-2 big'></i>
            <span className='me-2 d-lg-none d-xl-block'>Goods:</span>
            <span className={`${styles.detailValue}`}>
              <span>
                {props.user.product_count}
              </span>
              <span>
                {' '}Pieces
              </span>
            </span>
        </div>
    </>
  )
}
